import { ProjectMediaType } from 'api';

// "episode" is a full podcast episode pulled from a feed, so it carries audio
// media despite not being spelled "audio".
export function isAudioProject(
  mediaType: ProjectMediaType | undefined,
): boolean {
  return mediaType === 'audio' || mediaType === 'episode';
}
